import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';
import { useAuth } from './AuthProvider';

const Sidebar = () => {
    const { user, canRead } = useAuth();
    
    // Verificar permisos para cada sección
    const canAccessCotizaciones = canRead('acceso_cotizaciones');
    const canAccessNotasRecepcion = canRead('acceso_notas_recepcion');
    const canAccessInventario = canRead('acceso_inventario');
    const canAccessCatalogo = canRead('acceso_catalogo');
    const canAccessClientes = canRead('acceso_clientes');
    const canAccessUsuarios = canRead('acceso_usuarios');
    
    return(
        <div className='sidebar'>
            <nav className='sidebar-nav'>
                
                <Link className='sidebar-link' to="/home">
                    <div className='sidebar-item'>Home</div>
                </Link>
                
                {canAccessCotizaciones && (
                    <Link className='sidebar-link' to="/cotizaciones">
                        <div className='sidebar-item'>Cotizaciones</div>
                    </Link>
                )}
                
                {canAccessNotasRecepcion && (
                    <Link className='sidebar-link' to="/notasrecepcion">
                        <div className='sidebar-item'>Notas de recepcion</div>
                    </Link>
                )}
                
                {canAccessInventario && (
                    <Link className='sidebar-link' to="/inventario">
                        <div className='sidebar-item'>Inventario</div>
                    </Link>
                )}
                
                {canAccessCatalogo && (
                    <Link className='sidebar-link' to="/catalogo">
                        <div className='sidebar-item'>Catalogo</div>
                    </Link>
                )}
                
                {canAccessClientes && (
                    <Link className='sidebar-link' to="/clientes">
                        <div className='sidebar-item'>Clientes</div>
                    </Link>
                )}
                
                {canAccessUsuarios && (
                    <Link className='sidebar-link' to="/usuarios">
                        <div className='sidebar-item'>Usuarios</div>
                    </Link>
                )}
                
                {/* Comentado temporalmente hasta que se implemente */}
                <Link className='sidebar-link' to="/proceso">
                    <div className='sidebar-item'>Proceso</div>
                </Link>
                
            </nav>
            
        </div>
    );
};

export default Sidebar;